import React, { useState, lazy, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
// import Button from "../component/button/Button";
import { Button, input, Input } from "@heroui/react";
// import ButtonLoad from "../component/button/ButtonLoad";
// import InputTwo from "../component/input/InputTwo";

import LogoHandShake from "../icon/LogoHandShake";
import {
    HiOutlinePhone,
    HiOutlineLockClosed,
    HiOutlineEyeOff,
} from "react-icons/hi";

// import logo from "../img/logo/logo-mosyapay.png";

import { urlApi, urlApp } from "../setting/Url";
// import { AnimatePresence } from "framer-motion";
// import LogoGoogle from "../icon/login/LogoGoogle";
// import { IoEye, IoEyeOutline } from "react-icons/io5";
import { HiOutlineEye } from "react-icons/hi2";
// import LogoPhone from "../icon/LogoPhone";
// import LogoKey from "../icon/LogoKey";

const Login = () => {
    let navigate = useNavigate();

    const [data, setData] = useState({
        no_pelanggan: "",
        password: "",
    });

    const [loadButton, setLoadButton] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});

    const form = useRef(null);

    const handleChange = (e) => {
        const { name, value } = e.target;

        // update nilai input
        setData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // reset error hanya di field yang sedang diketik
        setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[name];
            return newErrors;
        });
    };

    const submitFormLogin = async (e) => {
        e.preventDefault();

        setLoadButton(true);

        try {
            const dataForm = {
                no_pelanggan: form.current.no_pelanggan.value,
                password: form.current.password.value,
            };

            // use fetch API for cek data
            let response = await fetch(`${urlApi}/api/pelanggan/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(dataForm),
            });
            let dataResponse = await response.json();
            if (response.status == 200) {
                window.localStorage.setItem(
                    "idUser",
                    dataResponse.data.user_id
                );
                window.localStorage.setItem(
                    "noPelanggan",
                    dataResponse.data.no_pelanggan
                );
                window.localStorage.setItem(
                    "nama",
                    dataResponse.data.nama_lengkap
                );
                window.localStorage.setItem(
                    "logged_in",
                    dataResponse.data.logged_in
                );
                window.localStorage.setItem("token", dataResponse.token);

                setData({
                    no_pelanggan: "",
                    password: "",
                });

                setLoadButton(false);

                navigate("/Home");
            }

            if (!response.ok) {
                // error dari server (misalnya validasi gagal, status 400)
                throw { status: response.status, dataResponse };
            }
        } catch (err) {
            console.log("Error terjadi:", err);

            if (err.status === 400 && err.dataResponse?.messages) {
                // error validasi dari backend
                setErrors(err.dataResponse.messages);
            } else {
                alert(
                    "Terjadi kesalahan: " +
                        (err.dataResponse?.message || err.message)
                );
            }
        } finally {
            setLoadButton(false);
        }
    };

    const openKebijakanPrivasi = () => {
        navigate("KebijakanLayanan", { state: { page: "Login" } });
    };

    return (
        <>
            <div className="w-full bg-white h-screen flex flex-col justify-center relative overflow-hidden px-3 tracking-tight">
                <div className="bg-white/55 p-2 rounded-lg shadow-lg">
                    <div className="flex flex-col mt-5 mb-7">
                        <h2 className="text-2xl font-bold mb-2 flex items-center">
                            Selamat Datang! <LogoHandShake />
                        </h2>
                        <p className="text-md text-gray-600">
                            Silahkan masuk dengan akunmu!
                        </p>
                    </div>
                    <div className="flex flex-col justify-around">
                        {/* <button className="mb-7 flex justify-center items-center font-semibold">
                        <div className="mr-2">
							<LogoGoogle /> 
						</div>
						<p>Login dengan Google</p>
                    </button>
                    <p className="uppercase text-center text-gray-400 mb-7">
                        atau
                    </p> */}
                        <form
                            ref={form}
                            onSubmit={submitFormLogin}
                            className="mt-2"
                        >
                            <div className="mb-10 w-full h-auto">
                                {/* <InputTwo
                                type="number"
                                name="no_pelanggan"
                                change={handleChange}
                                label="Masukan alamat Nomor WA-mu!"
                                icon={<HiOutlinePhone />}
                                placeholder="Masukan Nomor WA-mu!"
                            /> */}
                                <Input
                                    label="Nomor Wa"
                                    name="no_pelanggan"
                                    classNames={{
                                        input: [
                                            "text-medium",
                                            "text-black_m-300",
                                            "placeholder:text-medium",
                                        ],
                                        inputWrapper:
                                            "pt-7 group-data-[focus=true]:outline-none group-data-[focus=true]:ring-0 group-data-[focus=true]:border-transparent",
                                        label: "mb-5",
                                    }}
                                    placeholder="Masukan Nomor HP"
                                    type="number"
                                    size="lg"
                                    isRequired
                                    onChange={handleChange}
                                    value={data.no_pelanggan}
                                    isInvalid={!!errors.no_pelanggan}
                                    errorMessage={errors.no_pelanggan}
                                    // validate={(value) => {
                                    //     if (value.length === 0) {
                                    //         return "Nomor WA tidak boleh kosong";
                                    //     }
                                    // }}
                                    startContent={
                                        <HiOutlinePhone className="size-6 text-black_m-400" />
                                    }
                                />
                            </div>

                            <div className="mb-7 relative">
                                {/* <InputTwo
                                type={showPassword ? "text" : "password"}
                                name="password"
                                change={handleChange}
                                label="Masukan kata Sandimu!"
                                icon={<HiOutlineKey />}
                                placeholder="Masukan kata Sandimu!"
                            /> */}
                                <Input
                                    label="Password"
                                    name="password"
                                    classNames={{
                                        input: "text-medium placeholder:text-medium",
                                        inputWrapper:
                                            "pt-7 group-data-[focus=true]:outline-none group-data-[focus=true]:ring-0 group-data-[focus=true]:border-transparent",
                                        label: ["mb-5"],
                                    }}
                                    placeholder="Masukan Password"
                                    type={showPassword ? "text" : "password"}
                                    size="lg"
                                    isRequired
                                    onChange={handleChange}
                                    value={data.password}
                                    isInvalid={!!errors.password}
                                    errorMessage={errors.password}
                                    // validate={(value) => {
                                    //     if (value.length === 0) {
                                    //         return "Password tidak boleh kosong";
                                    //     }
                                    // }}
                                    startContent={
                                        <HiOutlineLockClosed className="size-7 text-black_m-400" />
                                    }
                                    endContent={
                                        <button
                                            type="button"
                                            className="text-xl"
                                            onClick={() =>
                                                setShowPassword(!showPassword)
                                            }
                                        >
                                            {showPassword ? (
                                                <HiOutlineEyeOff className="size-6 text-black_m-400" />
                                            ) : (
                                                <HiOutlineEye className="size-6 text-black_m-400" />
                                            )}
                                        </button>
                                    }
                                />
                            </div>
                            <div className="w-full flex justify-end mb-10">
                                <button
                                    type="button"
                                    className="text-sm font-semibold"
                                >
                                    Lupa Kata Sandi?
                                </button>
                            </div>
                            <Button
                                color="primary"
                                radius="sm"
                                type="submit"
                                fullWidth
                                size="md"
                                isLoading={loadButton}
                                className="bg-black_m-300 text-base py-6"
                            >
                                {loadButton ? "Loading" : "Login"}
                            </Button>
                        </form>
                    </div>

                    <div className="flex justify-center mt-7">
                        <p className="text-sm text-black_m-200">
                            Belum punya akun?
                        </p>

                        <Link
                            to="/Register"
                            className="block text-sm font-semibold hover:font-semibold relative after:absolute after:bottom-0 after:w-0 after:h-[2px] after:bg-black_m-400 after:left-0 hover:after:w-full after:transition-all ml-1"
                        >
                            Silahkan Daftar
                        </Link>
                    </div>

                    <p className="text-xs flex items-center justify-center mt-7">
                        <button
                            className="text-[11px] py-1 px-2 rounded-md underline"
                            onClick={() => openKebijakanPrivasi()}
                        >
                            Kebijakan Privasi & Ketentuan Layanan
                        </button>
                    </p>
                </div>
            </div>
        </>
    );
};

export default Login;
